interface IDetails {
  status: string;
  code: string;
  title: string;
  detail: string;
}

export interface ITintError {
  message: string;
  details?: IDetails;
}

export class TintError extends Error {
  public readonly message: string;
  public readonly details?: IDetails;
  public readonly type?: string;
  constructor({ message, details }: ITintError) {
    super(message);
    this.message = message;
    this.details = details;
  }
}
